module.exports = __webpack_public_path__ + "img/info_business.90e68c0.png";